import { Brick, BrickContext, registerBrick, Query, QueryResult } from 'olympe';
import System from '../../../models/System';
import Component from '../../../models/Component';
import Inspection from '../../../models/Inspection';
import Unit from '../../../models/Unit';
import AHPValue from '../../../models/AHPValue';

export default class LoadUnitSystems extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Unit} unit
     * @param {function()} forwardEvent
     * @param {function(Unit)} setLoadedUnit
     */
    async update($, [unit], [forwardEvent, setLoadedUnit]) {
        const systems = (await unit.follow(Unit.systemsRel).execute()).toArray();

        await Promise.all(systems.flatMap((system) => this.loadSystem($, system)));
        setLoadedUnit(unit);
        forwardEvent();
    }

    /**
     * @private
     * @param {!BrickContext} $
     * @param {!System} system
     * @return {!Promise<!Array<!QueryResult>>}
     */
    async loadSystem($, system) {
        const components = Query.from(system)
            .follow(System.allComponentsRel)
            .andReturn()
            .execute();
        const inspections = Query.from(system)
            .follow(System.allComponentsRel)
            .follow(Component.inspectionsRel, true)
            .andReturn()
            .follow(Inspection.presumedStatesRel, true)
            .andReturn()
            .execute();
        const rootComponents = Query.from(system)
            .andReturn()
            .follow(System.componentsRel)
            .execute();
        const subComponents = Query.from(system)
            .andReturn()
            .follow(System.allComponentsRel)
            .follow(Component.subComponentsRel)
            .execute();

        const ahpValuesComponents = Query.from(system)
            .follow(System.allComponentsRel)
            .follow(AHPValue.itemRel.getInverse())
            .andReturn()
            .follow(AHPValue.aspectRel)
            .andReturn()
            .execute();

        const ahpValuesInspections = Query.from(system)
            .follow(System.allComponentsRel)
            .follow(Component.inspectionsRel)
            .follow(AHPValue.itemRel.getInverse())
            .andReturn()
            .follow(AHPValue.aspectRel)
            .andReturn()
            .execute();

        return Promise.all([
            components,
            inspections,
            rootComponents,
            subComponents,
            ahpValuesComponents,
            ahpValuesInspections,
        ]).then((results) => {
            // Keep them in cache, avoid garbage collection until clear of this brick:
            const key = `loaded_system_${system.getTag()}`;
            $.set(key, results);
            $.onClear(() => $.remove(key));
        });
    }
}

registerBrick('01898e3bf0833d2d54b6', LoadUnitSystems);
